import React from 'react'
import _ from 'lodash'
import LOCALE from '../../AppLocale'
import { CATEGORIES } from '../product-constants'
import QuantitySelector from './QuantitySelector'
import Amount from './Amount'
import Message from './Message'

export default class Product extends React.Component {

    render() {
        const { appLocale, order, fees, amountChanged, adultQuantityChanged, childQuantityChanged, quantityChanged, isImaxChanged, includeMessage, messageChanged, isDigitalChanged } = this.props;
        const product = order.product;
        let quantity = <div className="quantity-container"><h4>{LOCALE[appLocale].quantity}</h4><QuantitySelector quantity={order.quantity} quantityChanged={quantityChanged} minQuantity={order.product.minQuantity} maxQuantity={order.product.maxQuantity} incrementBy={order.product.incrementBy}/></div>;
        let amount = null;
        let type = null;

        let adult = null;
        let child = null;
        let digital = null;

        switch (order.product.category) {
            case CATEGORIES.GIFTBOX:
                digital = order.product.availableAsPhysical ? <div className="quantity-container digital"><label>
                    {order.product.availableAsPhysical && order.product.availableAsDigital ? <input type="checkbox" checked={!order.isDigital} onChange={isDigitalChanged} /> : null}
                    {digital} {LOCALE[appLocale].giftBoxWithShipping} <span className="shippingCostText">{fees.shipping + (fees.handling * order.quantity)} {LOCALE[appLocale].currency}</span></label></div> : null;
                break;
            case CATEGORIES.GIFTCARD:
                const minMax = order.product.minAmount && order.product.maxAmount ? <span>({order.product.minAmount} - {order.product.maxAmount} {LOCALE[appLocale].currency})</span> : null;
                amount = <div className="quantity-container amount-container"><h4>{LOCALE[appLocale].amount} {minMax} </h4><Amount appLocale={appLocale} amount={product.price} amountChanged={amountChanged} maxAmount={product.maxAmount} /></div>
                digital = order.product.availableAsPhysical ? <div className="quantity-container digital"><label>{order.product.availableAsPhysical && order.product.availableAsDigital ?
                    <input type="checkbox" checked={!order.isDigital} onChange={isDigitalChanged} /> : null}{digital} {LOCALE[appLocale].giftCardWithShipping} <span className="shippingCostText">{fees.shipping} {LOCALE[appLocale].currency}</span></label></div> : null;
                break;
            case CATEGORIES.COMBOBOX:
                type = order.product.priceAdult ? <div className="quantity-container"><label><input type="checkbox" checked={order.isImax} onChange={isImaxChanged} />{LOCALE[appLocale].imax}</label></div> : null;
                adult = order.product.priceAdult ? <div className="quantity-container"><label>{LOCALE[appLocale].adult}</label><QuantitySelector quantity={order.adultQuantity} quantityChanged={adultQuantityChanged} minQuantity={order.product.minQuantity} maxQuantity={order.product.maxQuantity} incrementBy={order.product.incrementBy} /></div> : null;
                child = order.product.priceChild ? <div className="quantity-container"><label>{LOCALE[appLocale].child}</label><QuantitySelector quantity={order.childQuantity} quantityChanged={childQuantityChanged} minQuantity={order.product.minQuantity} maxQuantity={order.product.maxQuantity} incrementBy={order.product.incrementBy} /></div> : null;
                quantity = null;
                digital = order.product.availableAsPhysical ? <div className="quantity-container digital"><label>
                    {order.product.availableAsPhysical && order.product.availableAsDigital ? <input type="checkbox" checked={!order.isDigital} onChange={isDigitalChanged} /> : null}
                    {digital} {LOCALE[appLocale].giftBoxWithShipping} <span className="shippingCostText"> {fees.shipping + (fees.handling * order.quantity)} {LOCALE[appLocale].currency}</span></label></div> : null;
                break;
        }

        return (
            <div className="Product" >
                <div className="img-quantity">
                    <div><img src={product.image} alt={`${LOCALE[appLocale].giftBoxWithShipping} ` + product.name} /></div>
                    <div className="quantity-selectors">
                        {quantity}
                        {amount}
                        {type}
                        {adult}
                        {child}
                        {digital}
                    </div>

                </div>
                <div className="product-info">
                    <h1>{product.name}</h1>
                    <p dangerouslySetInnerHTML={{ __html: product.description }}></p>
                </div>
                {includeMessage ? <Message appLocale={appLocale} message={order.message} messageChanged={messageChanged} /> : null}
            </div>
        )
    }
}